import React, { Component } from 'react'
import { Footer } from '@cimpress/react-components'
import Header from '@cimpress-technology/react-platform-header/lib/Header'
import { connect } from 'react-redux'
import { Route, Switch, NavLink } from 'react-router-dom'
import { withRouter } from 'react-router'
import FourOhFour from './404'
import Setup from './Setup'
import Print from './Print'
import Contact from './Contact'
import auth from './../common/auth'
import { logIn as loginAction, logOut as logoutAction } from './../actions/auth'
import { configLocalization } from '../actions/localization'

class App extends Component {
	constructor() {
		super()
		this.handleLogIn = this.handleLogIn.bind(this)
		this.handleLogOut = this.handleLogOut.bind(this)
	}

	componentDidMount() {
		this.handleLogIn()
		this.props.configLocalization()
	}

	handleLogIn() {
		if (!this.props.isAuthenticated) {
			this.props.loginAction()
		}
	}

	handleLogOut() {
		if (this.props.isAuthenticated) {
			this.props.logoutAction()
		}
	}

	render() {
		return (
			<div>
				<Header
					appTitle={'Commercial Invoices'}
					appLinks={[
						<NavLink to="/setup">Setup</NavLink>,
						<NavLink to="/print">Print</NavLink>,
						<NavLink to="/contact">Contact</NavLink>
					]}
					profile={auth.getProfile()}
					isLoggedIn={this.props.isAuthenticated}
					onLogInClicked={this.props.loginAction}
					onLogOutClicked={this.props.logoutAction}
				/>
				<Switch>
					<AuthenticatedRoute
						exact
						path="/"
						isAuthenticated={this.props.isAuthenticated}
						component={Print}
					/>
					<AuthenticatedRoute
						exact
						path="/setup"
						isAuthenticated={this.props.isAuthenticated}
						component={Setup}
					/>
					<AuthenticatedRoute
						exact
						path="/print"
						isAuthenticated={this.props.isAuthenticated}
						component={Print}
					/>
					<Route path="/contact" component={Contact} />
					<Route path="*" component={FourOhFour} />
				</Switch>
				<Footer
					links={
						<ul>
							<a href="/contact">Contact Us</a>
						</ul>
					}
				/>
			</div>
		)
	}
}

const AuthenticatedRoute = ({
	component: Component,
	isAuthenticated,
	...rest
}) => (
	<Route
		{...rest}
		render={props => {
			if (isAuthenticated) {
				return <Component {...props} />
			} else {
				return <div> You are not logged in </div>
			}
		}}
	/>
)

export default withRouter(
	connect(
		state => ({
			isAuthenticated: state.auth.isAuthenticated
		}),
		{
			loginAction,
			logoutAction,
			configLocalization
		}
	)(App)
)



// WEBPACK FOOTER //
// ./src/components/App.js